module.exports = __webpack_public_path__ + "img/home_banner.878e057f.jpg";